import { useSession } from "@/contexts/sessionContext";
import useMediaQuery from "@/hooks/useMediaQuery";
import { useStore } from "@/hooks/useStore";
import { screens } from "@/modules/theme/screens";
import { SvgGlobe, SvgLocation } from "@getgrover/ui";
import { useMemo } from "react";
import { SelectWrapper, StyledSelect } from "./styles";

interface StoreAndLanguageSelectorProps {
  storeCode?: string;
  locale: string;
  onStoreChange: (store: string) => void;
  onLanguageChange: (locale: string) => void;
}

export const StoreAndLanguageSelector = ({
  storeCode,
  locale,
  onStoreChange,
  onLanguageChange,
}: StoreAndLanguageSelectorProps) => {
  const { user } = useSession();
  const { locales } = useStore();

  const stores = useMemo(
    () =>
      user?.stores
        ?.map(
          (store) =>
            store && {
              label: store.name,
              value: store.code,
            },
        )
        .filter((store) => store) as
        | { label: string; value: string }[]
        | undefined,
    [user],
  );

  const isDesktop = useMediaQuery(`(${screens.tablet})`);

  return (
    <SelectWrapper>
      {stores && (
        <StyledSelect
          $isDesktop={isDesktop}
          icon={<SvgLocation />}
          options={stores}
          onChange={(store) => {
            onStoreChange(store);
          }}
          value={storeCode || ""}
        />
      )}
      <StyledSelect
        $isDesktop={isDesktop}
        icon={<SvgGlobe />}
        options={locales}
        onChange={onLanguageChange}
        value={locale}
      />
    </SelectWrapper>
  );
};
